export const colorSystem = {
  // 60-30-10 Color Rule Implementation
  // 60% - Primary (Neutral/White)
  primary: {
    base: '#FFFFFF',
    light: '#FAFAFA',
    dark: '#F5F5F5',
  },
  
  // 30% - Secondary (Grays)
  secondary: {
    lightest: '#F8F9FA',
    lighter: '#E9ECEF',
    light: '#DEE2E6',
    base: '#ADB5BD',
    dark: '#6C757D',
    darker: '#495057',
    darkest: '#343A40',
  },
  
  // 10% - Accent (Blues - used sparingly)
  accent: {
    primary: '#0B98CE', // DaVinci Blue - Main CTA only
    secondary: '#316EA8', // DaVinci Denim - Secondary actions
    light: '#8FD7E5', // Beach - Hover states
    dark: '#143562', // Midnight - Text accents
  },
  
  // Supporting Colors
  support: {
    success: '#10B981',
    warning: '#F59E0B',
    error: '#EF4444',
    info: '#3B82F6',
  },
  
  // Background Patterns
  backgrounds: {
    primary: '#FFFFFF',
    secondary: '#FAFAFA',
    tertiary: '#F5F5F5',
    pattern: 'linear-gradient(to bottom, #FFFFFF 0%, #FAFAFA 100%)',
  },
  
  // Section Backgrounds (Alternating)
  sections: {
    odd: '#FFFFFF',
    even: '#FAFAFA',
    featured: 'linear-gradient(135deg, #FAFAFA 0%, #F5F5F5 100%)',
  },
  
  // Text Colors
  text: {
    primary: '#212529',
    secondary: '#495057',
    muted: '#6C757D',
    light: '#ADB5BD',
    inverse: '#FFFFFF',
  },
  
  // Border Colors
  borders: {
    light: '#E9ECEF',
    default: '#DEE2E6',
    dark: '#ADB5BD',
  },
};

// Spacing System (Reasonable spacing for modern design)
export const spacingSystem = {
  xs: '0.5rem',      // 8px
  sm: '1rem',        // 16px
  md: '1.5rem',      // 24px
  lg: '2rem',        // 32px
  xl: '3rem',        // 48px
  '2xl': '4rem',     // 64px
  '3xl': '5rem',     // 80px
  '4xl': '6rem',     // 96px
  '5xl': '8rem',     // 128px
  section: '5rem',   // Section spacing (80px)
  sectionMobile: '3rem', // Mobile section spacing (48px)
};

// Shadow System (Softer, more subtle)
export const shadowSystem = {
  xs: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  sm: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
  md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
  '2xl': '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
  inner: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)',
  none: 'none',
};

// Border Radius System
export const radiusSystem = {
  none: '0',
  sm: '0.125rem',
  md: '0.25rem',
  lg: '0.5rem',
  xl: '0.75rem',
  '2xl': '1rem',
  '3xl': '1.5rem',
  full: '9999px',
};